import { Environments } from './environments';

export const localEnvName = Environments.PANACLOUD_QA;
